<template>
    <div>
        <!-- Preloader -->
        <Preloader :loading="isLoading" />
        
        <!-- Custom Cursor -->
        <CustomCursor />
        
        <!-- Header -->
        <AppHeader />

        <!-- Main Content -->
        <main id="main-content">
            <router-view />
        </main>

        <!-- Footer -->
        <AppFooter />
        
        <!-- Back to Top -->
        <BackToTop />
        
        <!-- Chat Widget -->
        <ChatWidget />

        <!-- Gallery Lightbox (global, handles all gallery click events) -->
        <GalleryLightbox ref="galleryLightbox" />
    </div>
</template>

<script>
import AppHeader from '@/components/Common/AppHeader.vue'
import AppFooter from '@/components/Common/AppFooter.vue'
import Preloader from '@/components/Common/Preloader.vue'
import CustomCursor from '@/components/Common/CustomCursor.vue'
import BackToTop from '@/components/Common/BackToTop.vue'
import ChatWidget from '@/components/Common/ChatWidget.vue'
import GalleryLightbox from '@/components/Common/GalleryLightbox.vue'
import { useSiteDefaultsStore } from '@/stores/siteDefaultsStore'

export default {
    name: 'Main',
    components: {
        AppHeader,
        AppFooter,
        Preloader,
        CustomCursor,
        BackToTop,
        ChatWidget,
        GalleryLightbox
    },
    data() {
        return {
            isLoading: true,
            siteDefaultsStore: null
        }
    },
    async mounted() {
        this.siteDefaultsStore = useSiteDefaultsStore()
        
        try {
            // Load site defaults
            await this.siteDefaultsStore.loadSiteDefaults()
        } catch (error) {
            console.error('Failed to load site defaults:', error)
        } finally {
            // Always hide preloader after a maximum of 1.5 seconds
            // regardless of whether API calls succeed or fail
            setTimeout(() => {
                this.isLoading = false
            }, 1500)
        }

        // Listen for site defaults loaded event
        this.siteDefaultsStore.onSiteDefaultsLoaded((data) => {
            // Update document title
            if (data.siteName) {
                document.title = data.siteName
            }
            
            // Update meta description
            if (data.siteDescription) {
                const metaDescription = document.querySelector('meta[name="description"]')
                if (metaDescription) {
                    metaDescription.setAttribute('content', data.siteDescription)
                }
            }
        })
    },
    beforeUnmount() {
        if (this.siteDefaultsStore) {
            this.siteDefaultsStore.offAllEvents()
        }
    }
}
</script>

